<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JdI1QX/tc-custom/9781626811898.jpg?1734326273448" alt="This image is the cover for the book Disappeared Girl, The Memory Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Disappeared Girl, The Memory Series
      </h1>
      <p class="bookDescription body article font2">
        <b>The author of <i>Straw Men </i>continues his Memory Series with “a terrific read for lovers of political suspense” (Rebecca Forster, <i>USA Today–</i>bestselling author).</b><br/>  <br/> Two men stand out in a crowd overlooking the Ohio River. A plane is being removed from the water where it crashed decades before. Both men helped put it there.<br/>  <br/> Jim Christensen’s adopted daughter, Melissa, has been troubled of late. She has dreams that feel like memories, unsettling images percolate to the surface. She remembers a terrifying past, possibly her own, from a time before she was adopted. Christensen’s work as an expert in memory makes him the ideal person to help unlock his daughter’s fragile grasp on her own history. But will he want to learn the truth of where Melissa came from? Who she was before? Who might still be looking for her?<br/>  <br/> This dizzying novel of suspense takes the reader back into a dirty war and its human costs, into the fevered mind of one of its survivors, and through the crosshairs of a man desperate to keep his own history vanished.<br/>  <br/><b>Praise for the Memory Series novels</b><br/> “The creepiest good time I’ve had in ages—a genuine page-turner!” —Laura Lippman, <i>New York Times</i> bestselling author on <i>Straw Men</i><br/>  <br/> “[<i>Time Release</i>] is a spellbindingly accomplished first novel.” —James Ellroy, national bestselling author of <i>L.A. Confidential</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martin J. Smith
      </h2>
      
      <p class="authorDescription body article">Martin J. Smith, the fifty-nine-year-old veteran journalist and magazine editor, has won more than fifty newspaper and magazine writing awards. A former senior editor of the <I>Los Angeles Times Magazine</I>, Smith currently is editor-in-chief of <I>Orange Coast</I>, the market-leading monthly magazine of Orange County, CA.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a884ba0